export default "__VITE_ASSET__2265209a__"